var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 15 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fill: "#525252",
    d: "M23.578 34.617a1.24 1.24 0 0 1-.466-.106 1.088 1.088 0 0 1-.635-.995v-7.201l-7.16-7.138a1.088 1.088 0 0 1-.317-.784v-1.25c0-.614.487-1.1 1.101-1.1h16.86c.614 0 1.1.486 1.1 1.1v1.25c0 .297-.105.572-.317.784l-7.159 7.138v5.528c0 .317-.148.614-.38.826l-1.907 1.652c-.212.19-.466.296-.72.296zm-7.392-16.266l7.159 7.159c.212.212.318.487.318.783v7.011l1.715-1.483v-5.549c0-.296.106-.572.318-.783l7.159-7.16v-1.122H16.186v1.144z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.932472b311a32a9e38cca7bc2e2b2fa3.svg";
export { ForwardRef as ReactComponent };